//--------------------------------------------------
// imported classes
//--------------------------------------------------
const request = require('../../utils/request').default
const getQiniuUploadToken = require('../../api/qiniu').getQiniuUploadToken
const uploadImage = require('../../api/qiniu').uploadImage
const ClassFunc = require('../util/ClassFunc')
const GlobalFunc = require('../util/GlobalFunc')
const ObjectFunc = require('../util/ObjectFunc')
const Event = require('../event/Event')
const EventDispatcher = require('../event/EventDispatcher')
const FlowProcessor = require('../util/FlowProcessor')
const ModelLocator = require('../model/ModelLocator')

/**
 * The ServiceAgent acts as the agent for the service request.
 */
const tbs_service_ServiceAgent = function() {
    // console.log('tbs_service_ServiceAgent constructor')
    //--------------------------------------------------
    // super method for the base class
    //--------------------------------------------------
    ClassFunc.super(this, EventDispatcher, arguments);
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_service_ServiceAgent.prototype = {
    bulkCall: function(type, options) {
        // console.log('bulkCall', type, options)
        const self = this
        const servicesLength = options.services.length
        const repeatServices = []
        const callOptionsArray = []
        let fp

        const validateComplete = function() {
            let dataSets = []
            let fpServCount = 0
            for (let k = 0; k < servicesLength; k++) {
                let servRst = options.services[k]
                if (servRst.seq) {
                    fpServCount++
                }
                if (servRst.data) {
                    dataSets[k] = servRst.data
                }
                else {
                    continue
                }
            }

            // complete the dataSets via repeat services
            for (let r = 0; r < repeatServices.length; r++) {
                const item = repeatServices[r]
                dataSets[item.cur] = ObjectFunc.cloneObject(dataSets[item.prev])
            }

            // validate the dataSets completed or not
            let completedCount = 0
            for (let d = 0; d < dataSets.length; d++) {
                if (dataSets[d] != null) {
                    completedCount++
                }
            }
            // console.log('validate complete', fpServCount, completedCount, dataSets.length, servicesLength)
            if (completedCount == servicesLength) {
                self.dispatchEvent(new Event(type, {
                    dataSets: dataSets
                }))
            }
            else if (fpServCount > 0 && completedCount + fpServCount == servicesLength) {
                return fp.launch()
            }
        }

        for (let i = 0; i < servicesLength; i++) {
            let service = options.services[i]
            service.responser = type + service.service + i
            const parameters = options.parameters ? options.parameters[i] : {}
            const callOptions = {
                baseUrl: service.baseUrl,
                apiPrefix: service.apiPrefix,
                apiSuffix: service.apiSuffix,
                serviceName: service.service,
                method: options.method,
                parameters: parameters
            }
            let hit = false
            for (let j = 0; j < callOptionsArray.length; j++) {
                const callOptionsItem = callOptionsArray[j]
                if (ObjectFunc.compareObjects(callOptions, callOptionsItem.data)) {
                    hit = true
                    repeatServices.push({
                        prev: callOptionsItem.seq,
                        cur: i
                    })
                    break
                }
            }
            callOptionsArray.push({
                seq: i,
                data: callOptions
            })
            if (!hit) {
                // validate the seq attribute
                if (service.seq) {
                    if (!fp) {
                        fp = new FlowProcessor
                        const ctx = {fp: fp, options: options}
                        fp.regRules('BULK_SERVICE', {callback: function() {
                            return validateComplete()
                        }})
                        fp.regFunc('flowCall', [ctx, service, parameters, callOptions], self)
                    }
                }
                else {
                    self.addEventListener(service.responser, function(e) {
                        self.removeEventListener(e.type, e.handler)
                        for (let j = 0; j < servicesLength; j++) {
                            let servItem = options.services[j]
                            if (servItem.responser == e.type) {
                                servItem.data = e.data
                                return validateComplete()
                            }
                        }
                    })
                    self.call(service.responser, callOptions)
                }
            }
        }
    },
    flowCall: function(ctx, service, parameters, callOptions) {
        // console.log('flowCall', service, parameters, callOptions)
        const self = this
        self.addEventListener(service.responser, function(e) {
            self.removeEventListener(e.type, e.handler)
            for (let j = 0; j < ctx.options.services.length; j++) {
                let servItem = ctx.options.services[j]
                if (servItem.responser == e.type) {
                    servItem.data = e.data
                    return ctx.fp.launch()
                }
            }
        })
        self.validateParameters(parameters, ctx.options.services)
        self.call(service.responser, callOptions)
    },
    call: function(type, options) {
        // console.log('call', type, options)
        const self = this
        const fp = new FlowProcessor
        const ctx = {fp: fp, options: options, result: false}
        // options.baseUrl = options.baseUrl.replace("localhost", window.location.hostname)
        fp.regRules('SERVICE_CALL', {callback: function() {
            // console.log('SERVICE_CALL end')
            self.dispatchEvent(new Event(type, {
                result: ctx.result, 
                payload: ctx.payload,
                options: options
            }), true)
        }})
        // check the data contains image or not
        const images = this.checkImage(options.data)
        // console.log('images', images)
        if (images.length > 0) {
            if (ModelLocator.getStatus('imageServiceToken') == null) {
                fp.regFunc('getImageServiceToken', [ctx], this)
            }
            for (let i = 0; i < images.length; i++) {
                let image = images[i]
                // console.log('image', image)
                let imgObj = ctx.options.data[image]
                if (ClassFunc.getClass(imgObj) == 'Object') {
                    fp.regFunc('uploadImage', [ctx, image, imgObj], this)
                }
                else if (ClassFunc.getClass(imgObj) == 'Array') {
                    for (let j = 0; j < imgObj.length; j++) {
                        fp.regFunc('uploadImage', [ctx, image, imgObj[j], j, j == imgObj.length - 1], this)
                    }
                }
            }
        }
        fp.regFunc('requestService', [ctx], this)
        // console.log('SERVICE_CALL start')
        fp.launch()
    },
    getImageServiceToken: function(ctx) {
        getQiniuUploadToken({}).then(res => {
            ModelLocator.setStatus('imageServiceToken', res.data.token)
            ctx.fp.launch()
        })
    },
    uploadImage: function(ctx, prop, propValue, seq, isLast) {
         // console.log('uploadImage', prop, propValue, seq, isLast)
        if (seq == null) {
            const formData = new FormData()
             // console.log('uploadImage', propValue.file)
            formData.append('token', ModelLocator.getStatus('imageServiceToken'))
            formData.append('file', propValue.file)
            uploadImage(formData).then(res => {
                 // console.log('upload image complete object', prop, res.hash)
                ctx.options.data[prop] = res.hash
                ctx.fp.launch()
            })
        }
        else {
            if (seq == 0) {
                ctx.options.data[prop] = ''
            }
            if (ClassFunc.getClass(propValue) == 'String') {
                ctx.options.data[prop] += ',' + propValue
                if (isLast) {
                    ctx.options.data[prop] = ctx.options.data[prop].substr(1)
                }
                ctx.fp.launch()
            }
            else {
                const formData = new FormData()
                 // console.log('uploadImage', propValue.file)
                formData.append('token', ModelLocator.getStatus('imageServiceToken'))
                formData.append('file', propValue.file)
                uploadImage(formData).then(res => {
                     // console.log('upload image complete array', prop, res.hash)
                    ctx.options.data[prop] += ',' + res.hash
                    if (isLast) {
                        ctx.options.data[prop] = ctx.options.data[prop].substr(1)
                    }
                    ctx.fp.launch()
                })
            }
        }
    },
    requestService: function(ctx) {
         this.doRequest(ctx.options.baseUrl, ctx.options.apiPrefix, ctx.options.apiSuffix, 
             ctx.options.serviceName, ctx.options.method, ctx.options.parameters, 
             ctx.options.data).then(response => {
             // console.log('response', response)
             ctx.result = true
             ctx.payload = response
             ctx.fp.launch()
         })
    },
    doRequest: function(baseUrl, apiPrefix, apiSuffix, serviceName, method, parameters, data) {
        // console.log('doRequest', baseUrl, apiPrefix, apiSuffix, serviceName, method, parameters, data)
        if (apiSuffix) {
            parameters = ObjectFunc.mergeObject(parameters, ObjectFunc.parsePairString(apiSuffix))
        }
        if (data) {
            data.passport = GlobalFunc.getCookie('passport')
        }
        // support the dynamic service name via :property from the parameters
        serviceName = this.validateDynamicProperty(serviceName, parameters)
        // console.log('@serviceName', serviceName)
        
        return request({
            baseURL: baseUrl,
            url: ObjectFunc.mergePathUrl(apiPrefix, serviceName),
            method: method,
            params: parameters,
            data: data
        })
    },
    checkImage: function(data) {
        // console.log('checkImage', data)
        let images = []
        if (data) {
            for (let p in data) {
                // console.log(p, data[p])
                if (data[p] && data[p].type == 'image' && data[p].file) {
                    images.push(p)
                }
                else if (ClassFunc.getClass(data[p]) == 'Array') {
                    images.push(p)
                }
            }
        }
        return images
    },
    validateParameters: function(parameters, services) {
        // console.log('validateParameters', parameters, services)
        for (let p in parameters) {
            if (ClassFunc.getClass(parameters[p]) == 'String') {
                if (parameters[p].indexOf('^') > -1) {
                    const prop = parameters[p].substr(1)
                    parameters[p] = ObjectFunc.getObjectPropertyByPath(services, prop)
                }
            }
        }
        return parameters
    },
    validateDynamicProperty: function(name, parameters) {
        parameters = parameters || {}
        while (name.indexOf(':') > -1) {
            const startIndex = name.indexOf(':')
            const endIndex = name.indexOf('/', startIndex)
            let prop
            if (endIndex == -1) {
                prop = name.substring(startIndex + 1)
            }
            else {
                prop = name.substring(startIndex + 1, endIndex)
            }
            if (parameters[prop]) {
                name = name.replace(':' + prop, parameters[prop])
            }
            else {
                name = name.replace(':' + prop, '')
            }
        }
        return name
    },
}

//--------------------------------------------------
// extends the EventDispatcher
//--------------------------------------------------
ClassFunc.extend(tbs_service_ServiceAgent, EventDispatcher);

module.exports = tbs_service_ServiceAgent